<template>
  <div class="auth-page">
    <div class="auth-card">
      <div class="auth-brand auth-brand--register">
        <div class="auth-brand__title">Регистрация</div>
        <div class="auth-brand__subtitle">Создайте аккаунт и подтвердите email</div>
      </div>

      <form class="auth-form" @submit.prevent="register">
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input
            id="email"
            v-model.trim="email"
            type="email"
            class="form-control"
            placeholder="user@example.com"
            autocomplete="email"
            required
          />
        </div>

        <div class="mb-2">
          <label for="password" class="form-label">Пароль</label>
          <input
            id="password"
            v-model="password"
            type="password"
            class="form-control"
            placeholder="Минимум 8 символов"
            autocomplete="new-password"
            required
          />
        </div>

        <div class="password-hint mb-3">
          Минимум 8 символов, 1 цифра, 1 строчная и 1 заглавная буква.
        </div>

        <div class="mb-3">
          <label for="inviteCode" class="form-label">Инвайт-код</label>
          <input
            id="inviteCode"
            v-model.trim="inviteCode"
            type="text"
            class="form-control"
            placeholder="Введите код приглашения"
            autocomplete="off"
            required
          />
        </div>

        <div v-if="error" class="alert alert-danger py-2 mb-3">{{ error }}</div>

        <button class="btn btn-primary w-100" type="submit" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
          Зарегистрироваться
        </button>

        <div class="auth-footer">
          Уже есть аккаунт?
          <router-link to="/login">Войти</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/

export default {
  name: 'RegisterForm',
  data() {
    return {
      email: '',
      password: '',
      inviteCode: '',
      loading: false,
      error: '',
    }
  },
  methods: {
    validate() {
      if (!this.email) return 'Укажите email.'
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) return 'Введите корректный email.'
      if (!this.password) return 'Укажите пароль.'
      if (!PASSWORD_REGEX.test(this.password)) {
        return 'Пароль не соответствует требованиям безопасности.'
      }
      if (!this.inviteCode) return 'Укажите инвайт-код.'
      return ''
    },
    extractError(err) {
      const data = err?.response?.data
      const message = data?.message || data?.error
      if (typeof message === 'string' && message.includes('Username Already exist')) {
        return 'Пользователь с таким email уже существует.'
      }
      return String(message || 'Не удалось выполнить регистрацию.')
    },
    async register() {
      this.error = ''

      const validationError = this.validate()
      if (validationError) {
        this.error = validationError
        return
      }

      this.loading = true
      try {
        await axios.post(
          '/api/account/register',
          {
            email: this.email,
            password: this.password,
            inviteCode: this.inviteCode,
          }
        )

        this.$router.push({ name: 'RegisterSuccess', query: { email: this.email } })
      } catch (err) {
        console.error('Ошибка регистрации:', err)
        this.error = this.extractError(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.auth-page {
  min-height: calc(100vh - 102px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background:
    radial-gradient(circle at 18% 15%, rgba(255, 99, 71, 0.12), transparent 38%),
    radial-gradient(circle at 82% 82%, rgba(13, 110, 253, 0.11), transparent 45%),
    #f7f9fd;
}

.auth-card {
  width: 100%;
  max-width: 460px;
  background: #fff;
  border: 1px solid #e8edf7;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(17, 24, 39, 0.12);
  overflow: hidden;
}

.auth-brand {
  padding: 18px 20px 14px;
  color: #fff;
}

.auth-brand--register {
  background: linear-gradient(135deg, #0f766e, #10b981);
}

.auth-brand__title {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.25;
}

.auth-brand__subtitle {
  margin-top: 4px;
  font-size: 13px;
  opacity: 0.9;
}

.auth-form {
  padding: 18px 20px 20px;
}

.password-hint {
  color: #5f6f8b;
  font-size: 12px;
  line-height: 1.3;
}

.auth-footer {
  margin-top: 14px;
  font-size: 13px;
  color: #5f6f8b;
  text-align: center;
}

.auth-footer a {
  color: #1d5ed8;
  text-decoration: none;
  font-weight: 600;
}

.auth-footer a:hover {
  text-decoration: underline;
}
</style>
